import { useMutation } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks } from '../../types/my-types';

export default function useVerifyExtraction(
  extractionId: string,
  isVerified: boolean,
  callbacks: IRQCallbacks
) {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async () => {
      const response = await (await glynt).extraction.verify(extractionId, isVerified);
      return response;
    },

    ...callbacks
  });
}
